import Api from "../../Service/api";
import { T } from "../../app-utils/translator";
import { useContext, useEffect, useState } from "react";
import { AutoShipContext, LoadingContext, ProfileContext } from "../../App";
import { appMessage as message } from "../../app-utils/antdFeedback";

const api = new Api();

const Citon = ({ connector, refreshPaymentList }) => {

    const { setLoading } = useContext(LoadingContext);
    const { profileData } = useContext(ProfileContext);
    const { autoShipDetails } = useContext(AutoShipContext);
    const [citconIframeUrl, setCitconIframeUrl] = useState('');

    useEffect(() => {
        getCitconPayUrl();
        document.getElementsByClassName('listViewDiv')[0].classList.add('adjustHeight');
        return (() => document.getElementsByClassName('listViewDiv')[0]?.classList?.remove('adjustHeight'));
        // eslint-disable-next-line
    }, []);

    const getCitconPayUrl = async (currency, value) => {
        setLoading(true);
        const reqBody = {
            "issuerCode": profileData?.issuerCode,
            "midUuid": connector?.gatewayMidUuid,
            "currency": autoShipDetails?.currency,
            "source": 4
        }
        const result = await api.mainRestCallService('pgapi/initiate-payment-instrument', 'POST', reqBody);
        setLoading(false);
        if (result?.status === 1) {
            setCitconIframeUrl(result.data?.url);
        } else {
            message.error('Something went wrong, Please try again later.')
        }
    }

    useEffect(() => {
        window.addEventListener("message", addCardStatus);
        return (() => window.removeEventListener("message", addCardStatus));
        // eslint-disable-next-line
    }, []);


    const addCardStatus = (event) => {
        if (event.data === 'citcon_success') {
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
                refreshPaymentList();
                message.success(T('cardAddSuccess'));
            }, 3000);
        } else if (event?.data === 'citcon_failed') {
            setTimeout(() => {
                refreshPaymentList();
                message.error(T('cardAddFailText'));
            }, 3000);
        }
    };


    return (
        <div className="mt-4">
            {citconIframeUrl ? (
                <iframe
                    src={citconIframeUrl}
                    style={{ width: '100%', height: '600px', border: 'none' }}
                    title="Citcon Payment Frame"
                ></iframe>
            ) : (
                <div>Loading Citcon payment page...</div>
            )}
        </div>
    )
}

export default Citon;
